import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '@/components/Logo';
import Stage1Dashboard from './Stage1Dashboard';
import Stage3Dashboard from './Stage3Dashboard';
import Stage4LiveCandles from './Stage4LiveCandles';
import ReviewChat from './ReviewChat';

const TABS = [
  { id: 'stage1', label: 'Screener',     tag: 'S1' },
  { id: 'stage3', label: 'Analysis',     tag: 'S3' },
  { id: 'stage4', label: 'Live Candles', tag: 'S4' },
  { id: 'review', label: 'Review',       tag: '—'  },
];

const TradingApp = () => {
  const [activeTab, setActiveTab] = useState('stage1');

  return (
    <div className="min-h-screen bg-ink text-text-hi">

      {/* ── Header ─────────────────────────────────────────────────── */}
      <header className="sticky top-0 z-50 border-b border-haze bg-ink/95 backdrop-blur-md">
        <div className="flex h-14 items-center gap-6 px-6">

          {/* Logo — links back to main site */}
          <div className="shrink-0">
            <Logo />
          </div>

          {/* Vertical separator */}
          <div className="h-5 w-px shrink-0 bg-haze" />

          {/* Tab navigation */}
          <nav className="flex h-14 items-stretch">
            {TABS.map((tab) => {
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`relative flex items-center gap-2 px-4 text-sm transition-colors ${
                    isActive ? 'text-text-hi' : 'text-text-lo hover:text-text-hi'
                  }`}
                >
                  {/* Monospace stage tag */}
                  <span
                    className={`font-mono text-[10px] tracking-[0.15em] ${
                      isActive ? 'text-rule' : 'text-text-lo/40'
                    }`}
                  >
                    {tab.tag}
                  </span>
                  {tab.label}
                  {/* Active underline — the brand's gold rule */}
                  {isActive && (
                    <span className="absolute inset-x-0 bottom-0 h-px bg-rule" />
                  )}
                </button>
              );
            })}
          </nav>

          {/* Spacer */}
          <div className="flex-1" />

          {/* Right: status + back link */}
          <div className="flex items-center gap-5">
            <div className="flex items-center gap-2">
              <span className="h-1.5 w-1.5 rounded-full bg-signal animate-pulse-soft" />
              <span className="font-mono text-[11px] tracking-[0.12em] text-text-lo">
                PAPER
              </span>
            </div>
            <div className="h-4 w-px bg-haze" />
            <Link
              to="/"
              className="font-mono text-[11px] tracking-[0.12em] text-text-lo transition-colors hover:text-rule"
            >
              ← AEGIS
            </Link>
          </div>
        </div>

        {/* The brand's gold rule — visual spine */}
        <div className="rule-line" />
      </header>

      {/* ── Stage content ───────────────────────────────────────────── */}
      <main>
        {activeTab === 'stage1' && <Stage1Dashboard />}
        {activeTab === 'stage3' && <Stage3Dashboard />}
        {activeTab === 'stage4' && <Stage4LiveCandles />}
        {activeTab === 'review' && <ReviewChat />}
      </main>

    </div>
  );
};

export default TradingApp;
